import _ from 'lodash'
import RenderData from '../RenderData'
import { SIZE_TYPE } from './renderMixin'
import { mapGetters } from 'vuex'

export default {
  props: {
    rootRenderData: {
      type: RenderData,
      required: true
    },
    renderData: {
      type: RenderData,
      required: true
    },
    isEditMode: {
      type: Boolean,
      required: true
    },
    staticProps: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      form: {},
      SIZE_TYPE,
      sizeOptions: {
        height: _.map(SIZE_TYPE, (val, type) => ({
          labelI18nKey: `microSite.common.SIZE_TYPE.${type}`,
          value: val
        })),
        width: _.chain(SIZE_TYPE)
          .map((val, type) => ({
            labelI18nKey: `microSite.common.SIZE_TYPE.${type}`,
            value: val
          }))
          .filter((option) => option.value !== SIZE_TYPE.AUTO)
          .value()
      }
    }
  },
  computed: {
    ...mapGetters('microSite', ['isMobile'])
  },
  created () {

  },
  methods: {
    parseToInt (val) {
      return val && parseInt(val)
    },
    validateAndUpdateRenderData () {
      const msg = 'no override'
      throw msg
    },
    updateConfigInRoot () {
      if (!this.isEditMode) {
        const parent = this.renderData.parent || this.rootRenderData
        parent.children.splice(this.renderData.index, 0, this.renderData)
      }
    }
  }
}
